import { logger } from '../../common/logger';
import { brazeLoadScriptSrc } from './constants';

export function loadBraze(onScriptLoad: () => void) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = brazeLoadScriptSrc;
  script.onerror = e => {
    logger.error('Loading braze failed.', e);
  };
  script.onload = onScriptLoad;
  document.head.appendChild(script);
}
